module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-token-allocation-graphic js-token-allocation-canvas-container u-relative u-fit u-overflow-h"
  }, [_c('canvas', {
    staticClass: "js-token-allocation-canvas",
    attrs: {
      "id": "js-token-allocation-canvas"
    }
  }), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      staticClass: "c-token-allocation-graphic__data js-token-allocation-canvas-data u-absolute u-pos-tl u-align-center u-inline-block t-ffamily--simplon t-fsize--sm u-uppercase u-color--black"
    }, [_c('span', {
      staticClass: "u-inline-block u-color--brand-primary"
    }, [_vm._v(_vm._s(item.percent) + "%")]), _c('br'), _c('span', {
      staticClass: "u-inline-block"
    }, [_vm._v(_vm._s(item.label))])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-138293a0"}!./src/scripts/components/app-token-allocation-graphic/template.html
// module id = 454
// module chunks = 0